import { Divider, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

import getCustomerAssets from '~/auth/assets'
import EmailSupport from '~/components/EmailSupport'
import Link from '~/components/Link'
import { Overlay, createOverlay } from '~/components/Overlay'

import ReportIssueForm from './ReportIssueForm'

const HelpOverlay = createOverlay(() => {
  const t = useTranslations('layouts.HelpOverlay')
  const customerAssets = getCustomerAssets()

  return (
    <Overlay fullWidth maxWidth="sm">
      <Overlay.Header title={t('needHelpTitle')} />
      <Overlay.Content sx={{ px: 6, pt: 4, pb: 6 }}>
        <Typography variant="body1">
          {customerAssets?.supportEmail
            ? t.rich('emailUsAt', {
                email: () => <EmailSupport />
              })
            : t.rich('visitDocsOrEmail', {
                docLink: (chunks) => (
                  <Link href="https://synop.readme.io/" sx={{ fontWeight: 'bold' }} target="_blank">
                    {chunks}
                  </Link>
                ),
                email: () => <EmailSupport />
              })}
        </Typography>
        <Divider sx={{ my: 4 }} />
        <ReportIssueForm />
      </Overlay.Content>
    </Overlay>
  )
})

export default HelpOverlay
